import { usePoll } from '@tribeplatform/react-sdk/hooks'
import { Badge } from '@tribeplatform/react-ui-kit/Badge'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { T } from '../i18n/index.js'

import { CreatePollForm } from './CreatePollForm.js'
import { EditPollForm } from './EditPollForm.js'
import { PollStatusBadge } from './PollStatusBadge.js'
import { PollFormActionProps } from './types.js'

export interface PollFormDialogProps extends PollFormActionProps {
  id?: string
  open: boolean
}

export function PollFormDialog({ id, open, ...rest }: PollFormDialogProps) {
  const poll = usePoll(id)
  const isEditing = Boolean(id)

  return (
    <Modal open={open} onClose={rest.onCancel}>
      <Modal.Header
        title={
          <div className="flex items-center gap-2">
            {isEditing ? (
              <T id="Forms.Poll.Edit" defaultMessage="Edit poll" />
            ) : (
              <>
                <T id="Forms.Poll.Create" defaultMessage="New poll" />
                <Badge size="sm" variant="neutral">
                  <T defaultMessage="Beta" id="Generics.Beta" />
                </Badge>
              </>
            )}

            {poll && !poll.isDraft && <PollStatusBadge status={poll.status} />}
          </div>
        }
      />
      <Modal.Content className="py-0">
        {isEditing ? (
          <EditPollForm id={id} {...rest} />
        ) : (
          <CreatePollForm {...rest} />
        )}
      </Modal.Content>
    </Modal>
  )
}
